import { Refine } from '@refinedev/core';
import '../styles/globals.css';
import '@/styles/tailwind.css';
import type { AppProps } from 'next/app';
import { dataProvider } from '@/services/common/providers';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '@/authConfig';
import { PageLayout } from '@/components/PageLayout';
import { MsalProvider } from '@azure/msal-react';
import TenantAuthWrapper from '@/services/common/providers/TenantAuthWrapper';
import { useNotificationProvider } from '@refinedev/antd';
import { CommonContentProvider } from '@/utils/context/commonContent/CommonContentProvider';
import Script from 'next/script';
import { hotjarConfig } from '@/configs/hotjar.config';
import Head from 'next/head';
export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }
}).catch((error) => {
  console.error('MSAL initialization failed:', error);
});

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <MsalProvider instance={msalInstance}>
      <Refine dataProvider={dataProvider} notificationProvider={useNotificationProvider}>
        <CommonContentProvider>
          <Head>
            <title>GrowData OPS</title>
            <link rel="icon" href="/favicon.png" />
            <link href="https://atlas.microsoft.com/sdk/javascript/mapcontrol/2/atlas.min.css" rel="stylesheet" />
          </Head>
          <Script
            src="https://atlas.microsoft.com/sdk/javascript/mapcontrol/2/atlas.min.js"
            strategy="afterInteractive"
          />
          <PageLayout>
            <TenantAuthWrapper>
              <Component {...pageProps} />
              <Script
                id="HotJarAnalytics"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                  __html: hotjarConfig,
                }}
              />
            </TenantAuthWrapper>
          </PageLayout>
        </CommonContentProvider>
      </Refine>
    </MsalProvider>
  );
}

export default MyApp;
